<template>
  <wrap :title="$t('web_app.homeNotice.message')" @closeClick="handleCloseClick" @titleClick="toNotification">
    <div class="message_content">
      <div v-html="notification.content"></div>
      <div class="date">{{ notification.created_at }}</div>
      <div
        class="more"
        v-baidu-event-tracking="{ feature: '首页消息弹窗', action: '更多消息' }"
        v-if="unread_notifications_count > 1"
        @click="toNotification"
      >
        {{ $t('web_app.homeNotice.message_more', { message_count: unread_notifications_count }) }}
      </div>
    </div>
  </wrap>
</template>
<script>
import Wrap from './Wrap.vue'
import logClickEvent from '../../utils/logClickEvent'

export default {
  name: 'HomeNoticeMessage',
  components: {
    wrap: Wrap,
  },
  props: {
    closeClick: {
      type: Function,
      default: () => {},
    },
    notification: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    unread_notifications_count() {
      return this.$store.state.notifications.filter((notification) => {
        return !notification.readed
      }).length
    },
  },
  data() {
    return {
      user: this.$store.state.me,
    }
  },
  methods: {
    // 消息已读
    handleCloseClick() {
      logClickEvent('首页消息弹窗', '关闭')
      if (this.notification.readed) return
      this.markAsRead(() => {
        this.$emit('closeClick')
      })
    },
    toNotification() {
      logClickEvent('首页消息弹窗', '标题链接')
      this.markAsRead(() => {
        this.$emit('toNotification')
      })
    },
    // 已读消息
    markAsRead(callback) {
      this.$api.call('POST', '/notification/' + this.notification.id + '/mark_as_read', {}, (response) => {
        if (response.data && response.data.code === 0) {
          this.$store.commit('setNotificationReaded', this.notification.id)
          if (callback) callback()
        }
      })
    },
  },
}
</script>
<style lang="scss">
.message_content {
  padding: 0 10px;
  color: var(--memoContentColor);
  a {
    color: var(--tagColor);
  }
  .date {
    margin-top: 10px;
    font-size: 12px;
    color: #9d9d9d;
  }
  .more {
    padding: 5.5px 10px;
    border-radius: 6px;
    font-size: 12px;
    background: var(--bgGreen);
    color: white;
    display: inline-block;
    margin-top: 10px;
    cursor: pointer;
    font-weight: bold;
    &:hover {
      background: #2bba6d;
    }
  }
}
</style>
